export const mockData = {
  // JAECOO Data
  jaecoo: {
    stockTotal: 104,
    averageDaysInStock: 52.3,
    averagePrice: 23500,
    averageMarketDemand: 41.8,
    soldLast30Days: 89,
    averageMileage: 4200,
    // Days in Stock
    daysInStock: {
      series: [35, 13, 8, 7, 5, 5, 5, 5, 5, 16],
      labels: [
        '00-09 days',
        '10-19 days',
        '20-29 days',
        '30-39 days',
        '40-49 days',
        '50-59 days',
        '60-69 days',
        '70-79 days',
        '80-89 days',
        '90+ days'
      ]
    },

    // Dealer Type
    dealerType: {
      series: [5, 61, 34],
      labels: ['null', 'Franchise', 'Non-Franchise']
    },

    // Nearly New
    nearlyNew: {
      series: [2, 83, 15],
      labels: ['null', 'No', 'Yes']
    },

    // Percent
    percent: {
      series: [25, 30, 20, 15, 10],
      labels: ['0-20%', '21-40%', '41-60%', '61-80%', '81-100%']
    },

    // Market Demand
    marketDemand: {
      series: [14, 1, 0, 33, 44, 5, 3],
      labels: ['null', '10-19', '20-29', '30-39', '40-49', '50-59', '60-69']
    },

    // Model
    model: {
      series: [45, 35, 20],
      labels: ['Jaecoo: 7', 'Jaecoo: 7 Hybrid PHEV', 'Jaecoo: 9']
    },

    // Mileage
    mileage: {
      series: [0, 37, 14, 12, 14, 7, 5, 4, 0, 0, 7],
      labels: [
        'null',
        '0000-0099',
        '0100-0999',
        '1000-1999',
        '2000-2999',
        '3000-3999',
        '4000-4999',
        '5000-5999',
        '6000-6999',
        '7000-7999',
        '9000+'
      ]
    }
  },
  omoda: {
    stockTotal: 100,
    averageDaysInStock: 42.7,
    averagePrice: 24668,
    averageMarketDemand: 45.0,
    soldLast30Days: 114,
    averageMileage: 4712,
    // Days in Stock - Omoda sells faster than Jaecoo
    daysInStock: {
      series: [45, 18, 12, 8, 6, 4, 3, 2, 1, 1],
      labels: [
        '00-09 days',
        '10-19 days',
        '20-29 days',
        '30-39 days',
        '40-49 days',
        '50-59 days',
        '60-69 days',
        '70-79 days',
        '80-89 days',
        '90+ days'
      ]
    },

    // Dealer Type
    dealerType: {
      series: [2, 78, 20],
      labels: ['null', 'Franchise', 'Non-Franchise']
    },

    // Nearly New
    nearlyNew: {
      series: [1, 75, 24],
      labels: ['null', 'No', 'Yes']
    },

    // Percent
    percent: {
      series: [18, 22, 25, 22, 13],
      labels: ['0-20%', '21-40%', '41-60%', '61-80%', '81-100%']
    },

    // Market Demand
    marketDemand: {
      series: [8, 2, 3, 25, 38, 15, 9],
      labels: ['null', '10-19', '20-29', '30-39', '40-49', '50-59', '60-69']
    },

    // Model
    model: {
      series: [60, 25, 15],
      labels: ['Omoda: 5', 'Omoda: 5 EV', 'Omoda: 9 Hybrid PHEV']
    },

    // Mileage
    mileage: {
      series: [2, 45, 18, 15, 10, 5, 3, 2, 0, 0, 0],
      labels: [
        'null',
        '0000-0099',
        '0100-0999',
        '1000-1999',
        '2000-2999',
        '3000-3999',
        '4000-4999',
        '5000-5999',
        '6000-6999',
        '7000-7999',
        '9000+'
      ]
    }
  },
  buildYourDreams: {
    stockTotal: 102,
    averageDaysInStock: 45.6,
    averagePrice: 26746,
    averageMarketDemand: 45.5,
    soldLast30Days: 172,
    averageMileage: 4966,
    // Days in Stock
    daysInStock: {
      series: [15, 8, 10, 12, 15, 12, 12, 8, 6, 4],
      labels: [
        '00-09 days',
        '10-19 days',
        '20-29 days',
        '30-39 days',
        '40-49 days',
        '50-59 days',
        '60-69 days',
        '70-79 days',
        '80-89 days',
        '90+ days'
      ]
    },

    // Dealer Type
    dealerType: {
      series: [8, 35, 57],
      labels: ['null', 'Franchise', 'Non-Franchise']
    },

    // Nearly New
    nearlyNew: {
      series: [3, 65, 32],
      labels: ['null', 'No', 'Yes']
    },

    // Percent
    percent: {
      series: [10, 15, 18, 28, 29],
      labels: ['0-20%', '21-40%', '41-60%', '61-80%', '81-100%']
    },

    // Market Demand
    marketDemand: {
      series: [5, 0, 1, 15, 25, 30, 24],
      labels: ['null', '10-19', '20-29', '30-39', '40-49', '50-59', '60-69']
    },

    // Model
    model: {
      series: [40, 35, 25],
      labels: ['BYD: Tang', 'BYD: Atto 3', 'BYD: Seal']
    },

    // Mileage
    mileage: {
      series: [5, 25, 12, 15, 18, 10, 8, 5, 2, 0, 0],
      labels: [
        'null',
        '0000-0099',
        '0100-0999',
        '1000-1999',
        '2000-2999',
        '3000-3999',
        '4000-4999',
        '5000-5999',
        '6000-6999',
        '7000-7999',
        '9000+'
      ]
    }
  }
}
